module.exports = __webpack_public_path__ + "img/landing-footer-twitter.298238bd.svg";